import { checkShowLockIcon, showUpgradeOrRun } from '../../../helpers/vod';
import { Button, DetailedPoster, FontIcon } from '@intigral/shared';
import { VideoPopup } from '@intigral/ui';
import { __ } from '../../../translations';
import { useDispatch, useSelector } from 'react-redux';
import channelsUtil from '../../../helpers/channelsUtil';
import { LinkProps } from '@intigral/shared/components/LinkWrapper';
import { showUpgradedModal } from '../../../store/reducers/generalConfigurationSlice';
import { useConfigurationSections } from '../../../hooks/useConfiguration';
import f from '../../../helpers/formatter';

interface ICatchupPosterCardProps {
    catchupData: {
        Id: string;
        title: string;
        image: string;
        stationId?: string;
        startTime?: string;
        endTime?: string;
        ratings?: string;
        genre?: string[];
        subscriptionGuids?: string[];
        tvSeasonNumber?: number;
        tvSeasonEpisodeNumber?: number;
        dateTime?: string;
        // provider?: any;
    };
    keyId: string;
    link?: LinkProps;
    isShowDetailIcon?: boolean;
    isPlayButtonLoading?: boolean;
    isEpisode?: boolean;
    handlePlayClick?: () => void;
    handleOverLayDetailClick?: () => void;
    handleDetailCardClick?: () => void;
}

export default function CatchUpCard({
    catchupData,
    link,
    isShowDetailIcon,
    keyId,
    isPlayButtonLoading = false,
    isEpisode = false,
    handlePlayClick,
    handleOverLayDetailClick,
    handleDetailCardClick,
}: ICatchupPosterCardProps) {
    const userChannels = useSelector((state: any) => state.liveTv?.userChannels);
    // Using React Query instead of Redux for configuration
    const { paidVsFree, channelImage } = useConfigurationSections();
    const enableLockIcon = paidVsFree?.lockIconEnable || false;
    const channelImageId = channelImage?.id || 'colour_264x264';
    const channel = channelsUtil.getChannelByStationId(catchupData.stationId, userChannels);
    // const providerImage = channelsUtil.getSeletedChannelImage(channel, 'promo') || '';
    const providerImage = channelsUtil.getSeletedChannelImage(channel, channelImageId) || '';
    const guids = channel?.subscriptions.map((el) => el?.subscriptionGUID) || [];
    const isLocked = guids.length > 0 && checkShowLockIcon(guids) && enableLockIcon;
    const isVodLocked =
        catchupData?.subscriptionGuids && checkShowLockIcon(catchupData?.subscriptionGuids) && enableLockIcon;
    const isContentLocked = isLocked || isVodLocked;
    const dispatch = useDispatch();
    return (
        <VideoPopup
            key={`catcup-overlay-${keyId}`}
            heading={catchupData.title}
            picture={catchupData.image}
            cover={catchupData.image}
            play={
                isContentLocked ? (
                    <Button social compact onClick={() => dispatch(showUpgradedModal(true))}>
                        <FontIcon name="lock" size="smaller" md="smaller" className="locking" />
                    </Button>
                ) : (
                    <Button
                        primary
                        loading={isPlayButtonLoading}
                        onClick={() => {
                            if (handlePlayClick) {
                                handlePlayClick();
                            }
                        }}
                        compact
                    >
                        {__('play_now')}
                    </Button>
                )
            }
            rating={catchupData.ratings ? __(`rating_${catchupData.ratings.toLowerCase()}`) : null}
            provider={providerImage ? [providerImage, 0, 0] : null}
            info={[
                ...(catchupData.genre ?? []), // Ensure item.genre is an array
                // catchupData.startTime && catchupData.endTime
                //     ? `${f.formatRewindDate(catchupData.startTime, true)} - ${f.formatRewindDate(
                //           catchupData.endTime,
                //           false
                //       )}`
                //     : undefined,
            ].filter(Boolean)}
            page={
                isShowDetailIcon && !isContentLocked
                    ? {
                          LinkComponent: 'a',
                          social: true,
                          secondary: true,
                          compact: true,
                          children: 'Page',
                          onClick: (e) => {
                              if (handleOverLayDetailClick) {
                                  handleOverLayDetailClick();
                              }
                          },
                      }
                    : null
            }
        >
            <DetailedPoster
                key={`detail-card-${keyId}`}
                picture={catchupData.image}
                heading={catchupData.title}
                channelLogo={providerImage}
                // channelRatio={0.6}
                locked={isContentLocked}
                /** Figma: keep the info line, even if empty */
                info={
                    isEpisode
                        ? [
                              isEpisode && catchupData?.dateTime,
                              isEpisode && `S${catchupData?.tvSeasonNumber}:E${catchupData?.tvSeasonEpisodeNumber}`,
                          ]
                        : []
                }
                // {...locked && locked }
                // info={
                //     catchupData?.startTime && catchupData?.endTime && isEpisode
                //         ? [
                //             f.formatRewindDate(catchupData?.startTime, true, 'DD/MM'),
                //             `${f.formatRewindDate(catchupData?.startTime, false)} - ${f.formatRewindDate(
                //                 catchupData?.endTime,
                //                 false
                //             )}`,
                //         ]
                //         : []
                // }
                onClick={() => {
                    showUpgradeOrRun(isContentLocked, dispatch, () => {
                        if (handleDetailCardClick) {
                            handleDetailCardClick();
                        }
                    });
                }}
            />
        </VideoPopup>
    );
}
